// extracted by mini-css-extract-plugin
module.exports = {"list":"_1_W3ti","item":"RGzTdD","shine-lines":"_10yZqY"};